import React from "react";
import Styled from "styled-components";
import HomeCont from "../components/HomeCont";
import ImageCont from "../components/ImageCont";
function HomePage() {
  return (
    <MainCont>
      <ImageCont />
      <HomeCont/>
    </MainCont>
  );
}
const MainCont = Styled.div`
  min-height:100vh;
  display:flex;
  gap:3rem;
  align-items:center;
  background:linear-gradient(71deg,#fdb532 24%,#111 0%);
  animation-name:BottomToTop;
  animation-duration:1s;
  @media (max-width:768px){
    flex-direction:column;
    background:#111111;
    gap:0rem;
    // height:90vh;
    justify-content:space-around;
  }
`;
export default HomePage;
